// extracted by mini-css-extract-plugin
export default {"tridi-control-bar":"styles_tridi-control-bar__EU+N5","tridi-control-button":"styles_tridi-control-button__peLlj"};